import { useContext } from 'react';

import { RoleTypesEnum } from 'dash-common';
import { ViewerContext } from 'dash-ui';

import { Account } from 'gql/generated.graphql';

export const usePermissionCheck = () => {
  const viewerContext = useContext(ViewerContext);
  const account = viewerContext.account as Account;

  if (account.role.type === RoleTypesEnum.ORG_OWNER) {
    return true;
  }

  return false;
};
